import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getUserTypesSlice = createAsyncThunk(
  "userType/getUserTypes",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/userType/getUserTypes",
        userData, {
        headers: {
          "Content-Type": "application/json",
          "token": userData.token
        }
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  userTypes: [],
  loading: false,
};

const userTypeSlice = createSlice({
  name: "userType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserTypesSlice.pending, (state) => {
        state.loading = true;
        state.createSuccessMessage = null;
        state.createErrorMessage = null;
      })
      .addCase(getUserTypesSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.userTypes = action.payload.result.list;
      })
      .addCase(getUserTypesSlice.rejected, (state, action) => {
        state.loading = false;
        state.createErrorMessage = action.payload.result;
      });
  },
});

export default userTypeSlice.reducer;
